import React, { Fragment } from 'react'
import ReactSVG from 'react-svg'
import { Typography, Menu, Tooltip } from 'antd'
import './index.css'
import {
  customAI,
  live,
  stories
} from '../../../Courses/Create/nestedComponents/CourseCreateMain/images'
import NewHeader from '../../../../components/NewHeader'
const { Title } = Typography
const creationTypes = {
  live: 'live',
  custom: 'custom',
  stories: 'stories'
}
const FormHeader = ({
  t,
  isEnd,
  isRecording,
  podcastId,
  isMarketPlace,
  showAiGenerationOption,
  handleMenuClick,
  discussionRoomType
}) => {
  return (
    <Fragment>
      <div className="create-course">
        <div className="create-course__content">
          <Title level={4}>
            {isMarketPlace
              ? t('v4:marketplaceHeader')
              : isEnd
              ? t('v4:publishHeader')
              : podcastId
              ? t('v4:editHeader')
              : t('v4:createHeader')}
          </Title>
        </div>
        <div className="shl-podcast-head">
          <Tooltip
            placement="topLeft"
            title={
              !isEnd &&
              `${t('v5:recording')}: ${isRecording ? t('v5:on') : t('v5:Off')}`
            }
            arrow
          >
            <div className="podcast-record">
              <span style={{ color: isRecording && 'red' }}>REC</span>
              <i
                class={`podcast-record-icon ${isEnd &&
                  'podcast-record-disabled'} ${isRecording &&
                  'podcast-record-enabled'}`}
              ></i>
            </div>
          </Tooltip>
        </div>
        <NewHeader />
      </div>
      <div className="create-course-menu">
        {showAiGenerationOption && (
          <Menu
            selectedKeys={[discussionRoomType]}
            onClick={handleMenuClick}
            mode="horizontal"
          >
            <Menu.Item
              key={creationTypes.live}
              disabled={podcastId && creationTypes.live !== discussionRoomType}
            >
              <div className="create-course-box">
                <ReactSVG src={live} />
                {t('v4:create_podcast_live')}
              </div>
            </Menu.Item>
            <Menu.Item
              key={creationTypes.custom}
              disabled={
                podcastId && creationTypes.custom !== discussionRoomType
              }
            >
              <div className="create-course-box">
                <ReactSVG src={customAI} />
                {t('v4:create_podcast_custom')}
              </div>
            </Menu.Item>
            <Menu.Item
              key={creationTypes.stories}
              disabled={
                podcastId && creationTypes.stories !== discussionRoomType
              }
            >
              <div className="create-course-box">
                <ReactSVG src={stories} />
                {t('v4:create_podcast_stories')}
              </div>
            </Menu.Item>
          </Menu>
        )}
      </div>
    </Fragment>
  )
}

export { FormHeader }
